import React from 'react';
import Icon from '@/common/components/Icon';
import { TodoItemsListWrapper, TodoTitle } from './TodoStatus.styled';
import TodoListItem from './components/todoItem/TodoListItem';
import { TODO_STATUSES } from '@/common/constants/todoStatuses';

const TodoStatus = ({
	status,
	todos,
	hiddenStatuses,
	handleHiddenStatusesChange,
	handleEditTodo,
	updateStatus,
	loadingTodoId,
	loadData,
	notRead,
}) => {
	return (
		<div>
			<TodoTitle>
				<span>{TODO_STATUSES[status].title}</span>
				<Icon
					rotate={hiddenStatuses.includes(TODO_STATUSES[status].value)}
					color='white'
					name='fa fa-arrow-down'
					size={20}
					onClick={() =>
						handleHiddenStatusesChange(TODO_STATUSES[status].value)
					}
				/>
			</TodoTitle>
			<TodoItemsListWrapper
				hide={hiddenStatuses.includes(TODO_STATUSES[status].value)}
			>
				{todos
					.find((group) => group._id === TODO_STATUSES[status].value)
					?.data.map((todo) => (
						<TodoListItem
							status={status}
							loadData={loadData}
							loadingTodoId={loadingTodoId}
							updateStatus={updateStatus}
							handleEditTodo={handleEditTodo}
							todo={todo}
							key={todo._id}
							notRead={notRead}
						/>
					))}{' '}
			</TodoItemsListWrapper>
		</div>
	);
};

export default TodoStatus;
